import React from 'react';

import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router';

import { SxProp } from '@hrlogics/react-helper-types';

import { Nullable } from '@clearverify/types';

import { ResourceOriginType } from 'src/api';

interface ResourceLinkProps {
  originType: Nullable<ResourceOriginType>;
  url: string;
}

export const ResourceLink: React.FC<React.PropsWithChildren<ResourceLinkProps>> = ({
  originType,
  url,
  children,
}) => {
  if (originType === ResourceOriginType.Internal) {
    return (
      <Link component={RouterLink} to={url} sx={linkStyles}>
        {children}
      </Link>
    );
  }

  return (
    <Link href={url} color="inherit" target="_blank" rel="noopener noreferrer" sx={linkStyles}>
      {children}
    </Link>
  );
};

const linkStyles: SxProp = {
  textDecoration: 'none',
};
